




























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";

// Types
import { ISortableOptions, ISortableData } from "@/models/reordering";

@Component
export default class IndividualPromotionsVessels extends Vue {
  // Props
  @Prop({ required: true })
  public sortableData!: ISortableData[];

  @Prop({ default: null })
  public reorder!: Function;

  @Prop({ default: null })
  public addNew!: Function;

  @Prop({ required: true })
  public sortableItemName!: string;

  @Prop({ default: true })
  public isReorderable!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({
    default: i18n.t("_action.add_object", {
      object: i18n
        .t("_.product")
        .toString()
        .toLowerCase()
    })
  })
  public addMessage!: string;

  // Variables
  public sortElems: ISortableData[] = [];
  public savedOrder: ISortableData[] = [];

  public isReordering = false;

  public sortableOptions: ISortableOptions = {
    chosenClass: "dragged-vessel",
    handle: ".vessel-draggable"
  };

  public async onDragDrop() {
    this.isReordering = true;
    this.savedOrder = this.$_.cloneDeep(this.sortElems);

    try {
      await this.reorder(
        this.$_.map(this.sortElems, sortedElem => {
          return sortedElem.id;
        })
      );
      this.$store.dispatch("toast/show", {
        message: this.$t("_.order_updated")
      });
    } catch (error) {
      this.sortElems = this.$_.cloneDeep(this.savedOrder);
      this.$buefy.toast.open({
        message: this.$_.get(error, "message", ""),
        type: "is-danger"
      });
    }

    this.isReordering = false;
  }

  // Watch
  @Watch("sortableData", { immediate: true })
  public updateSortableData() {
    this.sortElems = this.$_.cloneDeep(this.sortableData);
    this.savedOrder = this.$_.cloneDeep(this.sortElems);
  }
}
